import {
  LANGUAGE_CHANGED,
} from '../../sharedTypes';

export const changeLanguage = language => ({
  type: LANGUAGE_CHANGED,
  data: { language },
});
